import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logo from './dsl-logo.png';

class Navbar extends Component {
  shouldComponentUpdate() {
    return false;
  }
  render() {
    return (
      <nav id="navbar" className="sticky">
        <div id="navbar-main">
          <Link to="/">
            <img src={logo} alt="logo" width="100" title="Home" />
          </Link>
        </div>
        <div id="scroll-position" />
      </nav>
    );
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar.js